import { cn } from '../../lib/cn';

const statusColors: Record<string, string> = {
  active: 'bg-green-500',
  inactive: 'bg-gray-400',
  pending: 'bg-yellow-500',
  closed: 'bg-red-500',
  lead: 'bg-blue-500',
  prospect: 'bg-indigo-500',
  customer: 'bg-green-500',
  churned: 'bg-red-400',
};

interface StatusDotProps {
  status: string;
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

export function StatusDot({ status, size = 'md', label, className }: StatusDotProps) {
  const dotSize = {
    sm: 'h-1.5 w-1.5',
    md: 'h-2 w-2',
    lg: 'h-2.5 w-2.5',
  }[size];

  const colorClass = statusColors[status.toLowerCase()] ?? 'bg-gray-400';

  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      <span className={cn('inline-block rounded-full', dotSize, colorClass)} />
      {label && <span className="text-sm text-slate-600">{label}</span>}
    </span>
  );
}
